"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconSave = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Save" }, props),
        react_1.default.createElement("title", null, "Save"),
        react_1.default.createElement("path", { d: "M59.918 111.431V82.856H31.343v28.575h28.575zM94.204 111.431V82.856H65.629v28.575h28.575z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M63.429 17.71c-4.35 0-8.55.643-12.515 1.822-4.018-6.568-11.228-10.96-19.489-10.96v22.96a43.948 43.948 0 00-9.996 17.036H8.57V77.1H22.2c6.236 16.714 22.34 28.607 41.229 28.607 24.3 0 44.003-19.703 44.003-44.003S87.729 17.71 63.429 17.71zM45.718 60a8.57 8.57 0 01-8.572-8.571 8.57 8.57 0 018.572-8.572 8.57 8.57 0 018.571 8.572c0 4.735-3.846 8.571-8.571 8.571z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M81.364 50.057v-9.14c11.54 0 20.915-9.385 20.915-20.914h9.15c0 16.575-13.49 30.054-30.065 30.054z", fill: "#000" }),
        react_1.default.createElement("path", { d: "M63.343 17.71c24.3 0 44.003 19.704 44.003 44.004 0 24.3-19.703 44.004-44.003 44.004", fill: "#D44513" })));
};
exports.default = BrandIconSave;
